module.exports = __webpack_public_path__ + "img/img29.dcdabfe4.svg";